
import * as yup from "yup";

export const RoleFormValidation = yup.object().shape({
    roleName: yup.string()
        .trim()
        .required('Enter Role Name'),
    privileges: yup.array()
});

export const UserFormValidation = yup.object().shape({
    firstName: yup.string()
        .trim()
        .required('Enter First Name'),
    lastName: yup.string()
        .trim()
        .required('Enter Last Name'),
    email: yup.string()
        .trim()
        .email('Invalid Email.')
        .required('Enter Email Address'),
    mobile: yup.string()
        .matches(/^\d+$/, "Phone Number must be only digits")
        .max(10, "Phone Number must be at most 10 digits")
        .required("Phone Number is required"),
    roleIds: yup
        .mixed()
        .required('At least one role needs to be assigned')
        .test(
            'is-object',
            'At least one role needs to be assigned',
            (value) => typeof value === 'object' && value !== null
        )
});

export const EditUserFormValidation = yup.object().shape({
    firstName: yup.string().trim()
        .required('Enter First Name'),
    lastName: yup.string().trim()
        .required('Enter Last Name'),
    email: yup.string().trim()
        .email('Invalid Email.')
        .required('Enter Email Address'),
    phone: yup.string()
        .matches(/^\d+$/, "Phone Number must be only digits")
        .max(10, "Phone Number must be at most 10 digits")
        .required("Phone Number is required"),
    roleIds: yup
        .mixed()
        .required('At least one role needs to be assigned')
        .test(
            'is-object',
            'At least one role needs to be assigned',
            (value) => typeof value === 'object' && value !== null
        )
});